import r from"./index.module.scss.js";import{MemoWrapperFactory as o}from"../Panel/PanelContentWrapperFactory.js";var a=o({wrapperClassName:r.tooltip,arrowBaseClass:r.tooltipArrow});export{a as TooltipWrapper};
//# sourceMappingURL=TooltipWrapper.js.map
